import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function CreateModal({
  createNewTaxRevenues,
  getNewTaxRevenuesList,
  history,
  getSingleNewTaxRevenues,
  creating,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    description: '',
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    description: 'required',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      code: _.get(formData, 'code').toUpperCase(),
      tax_revenue_type_id: '2',
      ordinance_revision_id: ordinanceRevisionId,
    };

    return createNewTaxRevenues(args, ({ data }) => {
      setModal({ isOpen: false });
      getNewTaxRevenuesList({ tax_revenue_type_id: 2, ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/permit/${_.get(data, 'id')}`);
      getSingleNewTaxRevenues(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description: {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getNewTaxRevenuesList: PropTypes.instanceOf(Function).isRequired,
  createNewTaxRevenues: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewTaxRevenues: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_TAX_REVENUES_PERMIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
